import { LOCALE_CHANGE } from '../actions/localization.actions';
import { ENGLISH } from "../constants/languages";
import { flattenMessages } from '../utils/localization.utils';
import englishMessages from '../localization/messages-en';

const INITIAL_LOCALIZATION_STATE = {
    locale: ENGLISH,
    messages: flattenMessages(englishMessages)
};

const localizationReducer = (state = INITIAL_LOCALIZATION_STATE, action = {}) => {

    switch (action.type) {
        case LOCALE_CHANGE:
            return { ...state, locale: action.payload.locale, messages: action.payload.messages };

        default:
            return state;
    }
};

export default localizationReducer;
